import React from "react";
import { useTranslation } from "react-i18next";
import useRevealSection from "../hooks/useRevealSection";

const Education: React.FC = () => {
  const { t } = useTranslation();
  const sectionRef = useRevealSection<HTMLElement>();

  return (
    <section className="education" id="education" ref={sectionRef}>
      <h2 className="heading reveal">
        {t("education.headingPre")} <span>{t("education.headingSpan")}</span>
      </h2>

      <div className="education-row">
        <div className="education-column">
          <h3 className="title">{t("education.educationTitle")}</h3>

          <div className="education-box stagger">
            <div className="education-content reveal">
              <div className="content">
                <div className="year">
                  <i className="bx bxs-calendar"></i> 2011 - 2014
                </div>
                <h3>{t("education.fh.title")}</h3>
                <p>{t("education.fh.desc")}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="education-column">
          <h3 className="title">{t("education.experienceTitle")}</h3>

          <div className="education-box stagger">
            <div className="education-content reveal">
              <div className="content">
                <div className="year">
                  <i className="bx bxs-calendar"></i> {t("education.itYears")}
                </div>
                <h3>{t("education.it.title")}</h3>
                <p>{t("education.it.desc")}</p>
              </div>
            </div>

            <div className="education-content reveal">
              <div className="content">
                <div className="year">
                  <i className="bx bxs-calendar"></i>{" "}
                  {t("education.selfEmployedYears")}
                </div>
                <h3>{t("education.selfEmployed.title")}</h3>
                <p>{t("education.selfEmployed.desc")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
